module.exports = [
    'carePlanSetting',
    'careReceive',
    'careUnReceive',
    'careDetail',
    'addSelfWelfare',
    'oms',
    'omsSupplement',
    'wx3rd',
    'content',
    'dataRightsPanel',
    'cardEdit',
    'birthdayTopic',
    'birthdayTemplateAdd',
    'selectCareScene',
    'selectedCareScene',
    'error',
    'application',
    'passive',
    // 'partnerList',
    // 'redpackEdit',
    // 'partnerList',
    // 'redpackEdit',
]